import { Card, Flex, Typography } from "antd";
import "./index.scss";
import SignInForm from "./SignInForm/SignInForm";

const SignIn = () => {
  return (
    <Flex align="center" justify="center" className="sign-in-container">
      <Card
        bordered
        className="card"
        title={
          <Typography.Title level={4} className="card-title">
            Sign in
          </Typography.Title>
        }
      >
        <SignInForm />
      </Card>
    </Flex>
  );
};

export default SignIn;
